export default __webpack_public_path__ + "static/media/6stpmain.7777aef7.webp";